module.exports = __webpack_public_path__ + "img/denti_i_logo_use.1432839c.png";